import React from 'react';

import {detailsNavigationIds} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';

import {
  BaseColumnWrap,
  CenteredDivWrap,
  FlexItem,
} from '../../../stories/components/CommonStyleUtils/dwebCommon.styles';

import * as S from './DetailsSeoReviews.styles';

const defaultReviewsCount = 4;
const DetailsSeoReviews = ({seoReviewsData}) => {
  const [showAllReview, setShowAllReview] = React.useState(false);

  const handleViewAllClick = () => {
    setShowAllReview(true);
  };

  if (!seoReviewsData?.reviews?.length) return null;

  return (
    <S.GuestRnRWrapper id={detailsNavigationIds.guestReviews}>
      <S.GuestRnRHeaderStyled>{seoReviewsData.seoTitle}</S.GuestRnRHeaderStyled>
      <S.GuestRnRListBlock>
        <S.ReviewListBlock>
          {seoReviewsData.reviews.map((item, index) => (
            <S.ReviewListItem
              key={`seo_review_${index}`}
              displayReview={index < defaultReviewsCount || showAllReview}
            >
              <CenteredDivWrap>
                <BaseColumnWrap>
                  {item.title && <S.HeadingPara>{item.title}</S.HeadingPara>}
                  <FlexItem>
                    {item.travellerName && <S.UsernameSpan>{item.travellerName}</S.UsernameSpan>}
                  </FlexItem>
                </BaseColumnWrap>
                {item.rating && <S.RatingSpan>{item.rating}/5</S.RatingSpan>}
              </CenteredDivWrap>

              {item.reviewContent && (
                <S.ReviewText dangerouslySetInnerHTML={{__html: item.reviewContent}} />
              )}
            </S.ReviewListItem>
          ))}
        </S.ReviewListBlock>
        {seoReviewsData?.reviews?.length >= defaultReviewsCount && !showAllReview ? (
          <S.TextBtnRead onClick={handleViewAllClick}>View All Reviews</S.TextBtnRead>
        ) : null}
      </S.GuestRnRListBlock>
    </S.GuestRnRWrapper>
  );
};

export default DetailsSeoReviews;
